var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { get } from 'lodash';
import { isDarkColor } from './is-dark-color';
import { isLightColor } from './is-light-color';
export var entityColorInfo = function entityColorInfo(entity, options) {
  var opts = __assign(__assign({}, options || {}), {
    defaultLightColor: '#FFFFFF',
    defaultDarkColor: '#000000'
  });

  var entityColor = get(entity, 'color.value');
  var entityBackgroundColor = get(entity, 'backgroundColor.value');
  var hasBothColors = !!entityColor && !!entityBackgroundColor;
  var hasColor = !!entityColor && !entityBackgroundColor;
  var hasBackgroundColor = !entityColor && !!entityBackgroundColor;
  var color = hasBothColors ? entityColor : hasBackgroundColor ? isDarkColor(entityBackgroundColor) ? opts.defaultLightColor : opts.defaultDarkColor : entityColor || opts.defaultDarkColor;
  var backgroundColor = hasBothColors ? entityBackgroundColor : hasColor ? isLightColor(entityColor) ? opts.defaultDarkColor : opts.defaultLightColor : entityBackgroundColor;
  var isInverted = isLightColor(color);
  return {
    color: color,
    backgroundColor: backgroundColor,
    isInverted: isInverted
  };
};
export var sliceColorInfo = entityColorInfo;